module.exports = __webpack_public_path__ + "img/364e545.png";